<template>
  <div class="must-read__wrapper">
    <p class="must-read__title">Must Read</p>
    <ul class="must-read__news-list">
      <li
        v-for="item in mustReadItems"
        :key="item.id"
        class="must-read__news-item"
      >
        <div class="must-read__link">
          <a-link
            :to="generateArticlePath(item.article)"
            :trailing-slash="!item.article.isMigrated"
            >{{ item.article.title }}</a-link
          >
        </div>

        <client-only>
          <div v-if="item.isSponsored" class="must-read__sponsored-label">
            Sponsored
          </div>
        </client-only>

        <client-only>
          <div v-if="item.isHighlighted" class="must-read__editorial-label">
            <a-icon
              :icon="$options.consts.ICON.STAR"
              :width="16"
              :height="16"
              original
              class="must-read__icon"
            />
            Editorial Pick
          </div>
        </client-only>
      </li>
    </ul>
  </div>
</template>

<script>
import ALink from 'shared/ALink'
import AIcon, { ICON } from 'shared/AIcon'
import mixins from '@/utils/mixins'
import { serverCacheKey } from '@/utils/mixins/serverCacheKey'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'

export default {
  name: 'MustRead',
  mixins: [mixins.urlGenerators, serverCacheKey],
  components: { ALink, AIcon },
  consts: {
    ICON
  },
  props: {
    mustReadItems: propValidator([PROP_TYPES.ARRAY])
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>

<style lang="scss">
.must-read__wrapper {
  background: $c--gray-soft;
  padding: 24px;
  width: 100%;
  border-radius: 4px;

  .must-read__title {
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;

    @include tablet {
      font-size: 20px;
    }
  }

  .must-read__news-list {
    margin-top: 10px;
  }

  .must-read__news-item {
    overflow: hidden;
    font-family: $font-body;
    font-size: 16px;
    font-weight: 300;
    line-height: 22px;
    border-bottom: 1px solid rgba($c--gray-2, 0.5);
    padding: 12px 12px 24px;

    a {
      color: $c--gray-dark-2;
      display: inline-block;

      &:hover {
        color: $c--main;
      }
    }
  }

  .must-read__sponsored-label,
  .must-read__editorial-label {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    margin-top: 12px;
    color: $c--gray-dark;
    background: $c--white;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    border-radius: 6px;
  }

  .must-read__sponsored-label {
    padding: 4px 10px;
  }

  .must-read__editorial-label {
    padding: 4px 10px 4px 6px;
  }

  .must-read__icon {
    margin-right: 4px;
  }
}
</style>
